import { parseCents } from "./money";
import { OPEN_GROUP_ACTION } from "./push-routing";

export const launchActions = {
  newExpense: "new-expense",
  newPayment: "new-payment",
  openGroup: OPEN_GROUP_ACTION,
};

const GROUP_ID = /^[1-9]\d{0,15}$/;

export const needsSelectedGroup = (launch) =>
  launch?.action !== launchActions.openGroup;

const SHARE_PARAMS = ["title", "text", "url"];
const MAX_NAME_LENGTH = 80;

const NUMBER = "(\\d{1,3}(?:[. \\u00a0]\\d{3})+|\\d+)(?:[,.](\\d{1,2}))?";
const AMOUNT = new RegExp(
  `(?:€|\\bEUR\\b)\\s*${NUMBER}(?!\\d)|(?:^|[^\\d.,])${NUMBER}\\s*(?:€|EUR\\b|Euro\\b)`,
  "gi",
);
const URL_PATTERN = /\bhttps?:\/\/\S+/gi;

const toCents = (euros, cents = "") =>
  parseCents(`${euros.replace(/\D/g, "")}${cents.padEnd(2, "0")}`);

export const parseAmount = (text = "") => {
  const amounts = new Set(
    [...`${text}`.matchAll(AMOUNT)].map((match) =>
      match[1] !== undefined
        ? toCents(match[1], match[2])
        : toCents(match[3], match[4]),
    ),
  );
  if (amounts.size !== 1) return 0;
  return [...amounts][0];
};

const cleanName = (text) =>
  `${text}`
    .replace(URL_PATTERN, " ")
    .replace(AMOUNT, " ")
    .split(/\r?\n/)
    .map((line) =>
      line.replace(/\s+/g, " ").replace(/^[\s:–-]+|[\s:–-]+$/g, ""),
    )
    .find(Boolean)
    ?.slice(0, MAX_NAME_LENGTH)
    .trim() || "";

export const parseSharedExpense = ({ title = "", text = "" } = {}) => ({
  name: cleanName(title) || cleanName(text),
  amount: parseAmount(`${title}\n${text}`.replace(URL_PATTERN, " ")),
});

export const parseLaunch = (search = "") => {
  const params = new URLSearchParams(search);
  const shared = Object.fromEntries(
    SHARE_PARAMS.map((key) => [key, params.get(key) || ""]),
  );
  const isShare = SHARE_PARAMS.some((key) => shared[key]);
  const action =
    params.get("action") || (isShare ? launchActions.newExpense : null);

  if (action === launchActions.openGroup) {
    const groupId = params.get("group") || "";
    return GROUP_ID.test(groupId) ? { action, groupId: Number(groupId) } : null;
  }
  if (action === launchActions.newPayment) return { action };
  if (action !== launchActions.newExpense) return null;
  return isShare ? { action, draft: parseSharedExpense(shared) } : { action };
};

export const withoutQuery = ({ pathname, hash }) => `${pathname}${hash}`;
